import { Injectable } from '@angular/core';
import { Router, Event, NavigationEnd } from '@angular/router';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AccessibilityService {
  private previousUrl: string = '';
  private currentUrl: string = '';

  constructor(private router: Router, private liveAnnouncer: LiveAnnouncer) {
    this.router.events
      .pipe(
        filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd)
      )
      .subscribe((event: NavigationEnd) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.urlAfterRedirects;
      });
  }

  private stripQueryParams(url: string): string {
    return url.split('?')[0];
  }

  announceNavigation(status: string) {
    const strippedPreviousUrl = this.stripQueryParams(this.previousUrl);
    const strippedCurrentUrl = this.stripQueryParams(this.currentUrl);

    if (strippedPreviousUrl === '/home' && strippedCurrentUrl === '/declaration') {
      if (status === 'success') {
        this.liveAnnouncer.announce($localize`You have verified successfully and navigated to Declaration page.  Use the screenreader to read the affirmation text`);
      }
    }
  }

  getPreviousUrl(): string {
    return this.previousUrl;
  }

  getCurrentUrl(): string {
    return this.currentUrl;
  }
}
